import Vue from "vue";
import Vuex from "vuex";
import * as actions from "./actions";
import * as getters from "./getters";
import mutations from "./mutations";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: false,
    token: "",
    username: ""
  },
  actions,
  getters,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js